/** @file viewportLayout: the full-resolution canvas and where the pixel-art target sits on it (pure). */
import type { CanvasFit } from '@zilo/pose3d-runtime-babylon/canvas/canvasFit';

/**
 * `fit`: the pixel-art target (`canvasFit`); `device`: the canvas backing store in device pixels (CSS size x dpr);
 * `offset`: the target's top-left on it, whole device pixels, centred as `canvasFit` centred the old canvas.
 */
export type ViewportLayout = { fit: CanvasFit; device: [number, number]; offset: [number, number] };

/** The layout of a `cssW x cssH` box: backing store `round(css x dpr)`, the `fit.scale`-times target centred (floored). */
export function viewportLayout(cssW: number, cssH: number, fit: CanvasFit): ViewportLayout {
  const w = Math.max(1, Math.round(cssW * fit.dpr));
  const h = Math.max(1, Math.round(cssH * fit.dpr));
  return { fit, device: [w, h], offset: [Math.floor((w - fit.width * fit.scale) / 2), Math.floor((h - fit.height * fit.scale) / 2)] };
}
